import {
  Box,
  Flex,
  Heading,
  Image,
  SimpleGrid,
  Tag,
  Text,
  useColorModeValue,
  VStack,
  AspectRatio,
  Badge,
  Icon,
  HStack,
  useBreakpointValue,
  Container,
  Stack,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaMapMarkerAlt, FaCalendarAlt, FaBuilding } from "react-icons/fa";
import { MdVisibility } from "react-icons/md";
import * as Constants from "../../../constants/Constants";
import axios from "axios";
// import glass1 from "../../../assets/images/glass1.jpg";
// import glass12 from "../../../assets/images/glass12.jpg";
// import glass13 from "../../../assets/images/glass13.jpg";
// import glass2 from "../../../assets/images/glass2.jpg";
// import glass3 from "../../../assets/images/glass3.jpg";
// import glass4 from "../../../assets/images/glass4.jpg";
// import glass5 from "../../../assets/images/glass5.jpg";
// import glass7 from "../../../assets/images/glass7.jpg";
import Header from "../header/Header";
import { useHomeHook } from "../home/useHomeHook";
import Footer from "../footer/Footer";

const MotionBox = motion(Box);
const MotionImage = motion(Image);

const Project = (props) => {
  const [hoveredId, setHoveredId] = useState(null);
  const bgColor = useColorModeValue("white", "#000000");
  // const borderColor = useColorModeValue('#000000', '#000000');
  const textColor = useColorModeValue("#000000", "#000000");
  const accentColor = useColorModeValue("black");
  const cardShadow = useColorModeValue("xl", "dark-lg");
  const isMobile = useBreakpointValue({ base: true, md: false });
  console.log(hoveredId);
  const mutedTextColor = useColorModeValue("#000000", "#000000");
  const [handleMenuEnter, handleMenuLeave, menuVisible, setHoveredItem] =
    useHomeHook(props);
      const [images, setImages] = useState([]);
      useEffect(() => {
        axios
          .get(Constants.REACT_APP_API_URL + "api/upload/project")
          .then((res) => {
            if (res.data.success) {
              setImages(res.data.data);
            }
          })
          .catch((err) => console.log(err));
      }, []);
      const projects = [
  {
    id: 1,
    src: images[0]?.image_url,
    alt: "Luxury Glass Partition",
    title: "Corporate Office",
    shortDescription:
      "Modern glass partitions for a corporate office space in Mumbai designed to enhance natural light while maintaining privacy.",
    status: "Completed",
    category: "Commercial",
    location: "Mumbai",
    year: "2024",
    features: ["Frosted glass", "Soundproofing", "Custom framing"],
    relatedImages: [images[0]?.image_url, images[3]?.image_url, images[2]?.image_url],
  },
  {
    id: 2,
    src: images[1]?.image_url,
    alt: "Residential Bungalow",
    title: "Residential Bungalow",
    shortDescription:
      "Stylish residential bungalow featuring luxury glass facades and custom doors for modern living.",
    status: "Completed",
    category: "Commercial",
    location: "Bangalore",
    year: "2024",
    features: ["Double glazing", "UV protection", "Smart glass"],
    relatedImages: [images[6]?.image_url, images[0]?.image_url, images[4]?.image_url],
  },
  {
    id: 3,
    src: images[2]?.image_url,
    alt: "Residential Interior",
    title: "Luxury Apartment",
    shortDescription:
      "High-end residential interior with premium glass installations and custom finishes.",
    status: "Completed",
    category: "Residential",
    location: "Delhi",
    year: "2023",
    features: ["Tempered glass", "Decorative etching", "Integrated lighting"],
    relatedImages: [images[5]?.image_url, images[6]?.image_url, images[7]?.image_url],
  },
  // {
  //   id: 4,
  //   src: images[6]?.image_url,
  //   alt: "Hotel Project",
  //   title: "Five Star Hotel",
  //   shortDescription:
  //     "Exclusive door and partition solutions for luxury hotel with enhanced safety features.",
  //   status: "Completed",
  //   category: "Hospitality",
  //   location: "Goa",
  //   year: "2024",
  //   features: ["Laminated glass", "Automatic doors", "Fire-rated"],
  //   relatedImages: [images[7]?.image_url, images[4]?.image_url, images[1]?.image_url],
  // },
  // {
  //   id: 5,
  //   src: images[3]?.image_url,
  //   alt: "Shopping Mall",
  //   title: "Retail Complex",
  //   shortDescription:
  //     "Modern glass installations for premium shopping center with maximum visibility.",
  //   status: "Completed",
  //   category: "Commercial",
  //   location: "Ahmedabad",
  //   year: "2023",
  //   features: ["Curved glass", "Anti-reflective coating", "Structural glazing"],
  //   relatedImages: [images[3]?.image_url, images[2]?.image_url, glass1],
  // },
];

  return (
    <Box bg={useColorModeValue("#FFFFFF", "#FFFFFF")} >
      <Header
        handleMenuEnter={handleMenuEnter}
        handleMenuLeave={handleMenuLeave}
        menuVisible={menuVisible}
        setHoveredItem={setHoveredItem}
        collections={[
          { name: "Sliding Partitions", path: "/product/1" },
          { name: "Swing Partitions", path: "/product/2" },
          // { name: "Flush Doors", path: "/product/3" },
          { name: "Bathroom & Wardrobes", path: "/product/4" },
          { name: "Shower Enclosures", path: "/product/5" },
          { name: "Led Mirrors", path: "/product/6" },
        ]}
      />

      <Container maxW="container.xl" px={{ base: 4, md: 8 }} py={16}>
        <Box
          mb={8}
          textAlign="center"
          p={6}
          // bgGradient="linear(to-r, #87CEEB, #800080)"
          borderRadius="xl"
        >
          <Stack alignItems="center">
            {/* <Badge
        bgGradient="linear(to-r, gold.400, gold.600)"
        color="white"
        px={8}
        py={4}
        borderRadius="full"
        fontSize="md"
        fontWeight="bold"
        boxShadow="md"
      >
        COLLECTION
      </Badge> */}
            <Heading
              as="h1"
              size={{base:"lg",md:"2xl"}}
              // bgGradient="linear(to-r, #87CEEB, #800080)"
              // bgClip="text"
              color="#000000"
              lineHeight="tall"
              fontWeight="semibold"
              fontFamily="system-ui, sans-serif"
            >
              Showcase of Excellence
            </Heading>
            <Box
              overflow={{ base: "hidden", md: "visible" }}
              textOverflow={{ base: "ellipsis", md: "initial" }}
              whiteSpace={{ base: "normal", md: "nowrap" }}
            >
              <Text
                fontSize={{ base: "md", md: "lg" }}
                color={mutedTextColor}
                letterSpacing="-0.5px"
              >
                Discover sleek, innovative glass installations crafted with enduring style and precision.
              </Text>
            </Box>
          </Stack>
        </Box>
        {/* <VStack spacing={8} mb={12} textAlign="center">
          <Box>
            <Badge
              bgGradient="linear(to-r, cyan.500, #87CEEB)"
              color="white" 
              px={10}
              py={8}
              borderRadius="full"
              fontSize="lg"
              mb={4}
              fontWeight="bold"
              textTransform="uppercase" 
              lineHeight="0.3"
            >
              OUR PORTFOLIO
            </Badge>
            <Heading
            as="h1"
            size="2xl"
            textAlign="center"
            bgGradient="linear(to-r, cyan.500, #87CEEB)"
            bgClip="text"
            fontWeight="extrabold"
            lineHeight="1.2"
          >
            Our Projects
          </Heading>
            <Heading
              as="h1"
              size="2xl"
              bgGradient="linear(to-r, #87CEEB, #800080)"
              bgClip="text"
              fontWeight="extrabold"
              lineHeight="1.2"
            >
              Showcase of Excellence
            </Heading>
          </Box>
          <Text
            fontSize={{ base: "md", md: "lg" }}
            color={textColor}
            maxW="3xl"
          >
            Discover our curated collection of premium glass installations that
            blend innovation with timeless elegance.
          </Text>
        </VStack> */}

        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={8}>
          {projects.map((project) => (
            <MotionBox
              key={project.id}
              as={Link}
              to={`/ProjectDetails/${project.id}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              onMouseEnter={() => setHoveredId(project.id)}
              onMouseLeave={() => setHoveredId(null)}
              bg={bgColor}
              overflow="hidden"
              boxShadow={cardShadow}
              borderRadius="xl"
              position="relative"
              _hover={{
                transform: "translateY(-8px)",
                boxShadow: "2xl",
                "& .project-overlay": {
                  opacity: 1,
                },
              }}
              // transition="all 0.3s ease"
            >
              {/* Image with overlay */}
              <Box position="relative" overflow="hidden">
                <AspectRatio ratio={4 / 3}>
                  <MotionImage
                    src={project.src}
                    alt={project.alt}
                    objectFit="cover"
                    w="100%"
                    transition="transform 0.5s ease"
                    whileHover={{ scale: 1.05 }}
                  />
                </AspectRatio>

                {/* Status badge */}
                <Badge
                  position="absolute"
                  top={4}
                  right={4}
                  bg="black" 
                  opacity={0.7}
                  // colorScheme={
                  //   project.status === "Completed"
                  //     ? "black"
                  //     : project.status === "In Progress"
                  //     ? "black"
                  //     : "black"
                  // }
                  color={"white"}
                  px={3}
                  py={1}
                  borderRadius="full"
                  fontSize="sm"
                  zIndex={1}
                >
                  {project.status}
                </Badge>

                {/* Hover overlay */}
                <Box
                  className="project-overlay"
                  position="absolute"
                  top={0}
                  left={0}
                  right={0}
                  bottom={0}
                  bg="blackAlpha.600"
                  opacity={0}
                  transition="opacity 0.3s ease"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Text
                    color="white"
                    fontWeight="bold"
                    fontSize="lg"
                    textAlign="center"
                    px={4}
                  >
                    <Icon as={MdVisibility} color="white" opacity={0.7} boxSize={8} />
                  </Text>
                </Box>
              </Box>

              {/* Project content */}
              <VStack p={6} align="start" spacing={4}>
                <Heading as="h3" size="lg" color={accentColor}>
                  {project.title}
                </Heading>

                <Text color={textColor} noOfLines={3}>
                  {project.shortDescription}
                </Text>

                {/* Features chips */}
                <Flex wrap="wrap" gap={2} mt={2}>
                  {project.features
                    .slice(0, isMobile ? 2 : 3)
                    .map((feature, index) => (
                      <Tag
                        key={index}
                        size="sm"
                        variant="subtle"
                        // colorScheme="blue"
                        borderRadius="full"
                                          bg="black" 
                  opacity={0.7}
                  color={"white"}
                      >
                        {feature}
                      </Tag>
                    ))}
                </Flex>

                {/* Meta information */}
                <Flex
                  width="full"
                  justify="space-between"
                  mt={4}
                  color="#000000"
                  fontSize="sm"
                >
                  <HStack spacing={2}>
                    <Icon as={FaMapMarkerAlt} boxSize={4} />
                    <Text>{project.location}</Text>
                  </HStack>
                  <HStack spacing={2}>
                    <Icon as={FaCalendarAlt} boxSize={4} />
                    <Text>{project.year}</Text>
                  </HStack>
                  <HStack spacing={2}>
                    <Icon as={FaBuilding} boxSize={4} />
                    <Text>{project.category}</Text>
                  </HStack>
                </Flex>
              </VStack>
            </MotionBox>
          ))}
        </SimpleGrid>
      </Container>
      <Footer />
    </Box>
  );
};

export default Project;
